// src/app/core/store/profile/profile.state.ts

import { UserProfile } from '@core/services/account.service';

export interface CacheEntry<T> {
  data: T;
  loadedAt: number;
  ttlMs: number;
}

export function isCacheValid<T>(entry: CacheEntry<T> | null | undefined): boolean {
  if (!entry) return false;
  return Date.now() - entry.loadedAt < entry.ttlMs;
}

export const PROFILE_TTL = 15 * 60 * 1000; // 15 min

export interface AsyncSlice<T> {
  data: T | null;
  loading: boolean;
  loaded: boolean;
  error: string | null;
  cache: CacheEntry<T> | null;
}

export function emptySlice<T>(): AsyncSlice<T> {
  return { data: null, loading: false, loaded: false, error: null, cache: null };
}

export interface ProfileState {
  profile: AsyncSlice<UserProfile>;
}

export const initialProfileState: ProfileState = {
  profile: emptySlice(),
};
